<template>
  <v-dialog max-width="500px"
            v-model.sync="localDialog">
    <template v-slot:activator="{on, attrs}">
      <v-btn v-bind="attrs"
             v-on="on"
             icon
             v-if="icon">
        <v-icon>
          fal fa-question-circle
        </v-icon>
      </v-btn>
      <v-btn class="ml-4"
             v-bind="attrs"
             v-on="on"
             v-else>
        Help
      </v-btn>
    </template>
    <v-card flat
            tile>
      <v-card-title>
        <slot name="title">
          Under Construction
        </slot>
      </v-card-title>
      <v-card-text>
        <slot name="content">
          <p>
            This will provide instructions.
          </p>
        </slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      localDialog: this.dialog,
    }
  }
}
</script>
